import { useMutation } from '@tanstack/react-query'
import { submitPropertyConsignment } from "../api/post-property-consignment"

export const useSubmitPropertyConsignment = (options = {}) => {
  return useMutation({
    mutationFn: (params) => submitPropertyConsignment(params),
    ...options
  })
}